export const integrationsDirectCdiImportSyncsAll = "/integrations/direct/cdi/import-syncs/all";
